import { ConsumerLoanTargetPath } from '../domain/types';
import { IFieldState } from '../store/applicationform/applicationFormTypes';
import { AuthenticationData } from '../store/authentication';
import { CountryCode } from '../types/CountryCode';
import { LanguageCode } from '../types/LanguageCode';
import { apiClient } from './apiClient';
import { Debt } from './getDebts';
import { callbackUrl, dataFormPage } from './util';

export const createSubmitPayload = (
    applicationId: string,
    languageCode: string,
    countryCode: string,
    formFieldsInput: IFieldState[],
    consentFieldsInput: IFieldState[],
    consolidations: Debt[],
    kycTemplateVersion?: number,
) => {
    return {
        ...dataFormPage({ applicationId }, formFieldsInput, consentFieldsInput),
        callbackUrl: callbackUrl(ConsumerLoanTargetPath.callback, languageCode, countryCode, ''),
        applicationUrl: callbackUrl(ConsumerLoanTargetPath.ongoing, languageCode, countryCode, ''),
        consolidations: consolidations ?? [],
        kycTemplateVersion,
    };
};

export type SubmitApplicationResponse = {
    applicationReferenceNumber: string;
};

export const submitApplicationService = async (
    apiProxyPath: string,
    languageCode: LanguageCode,
    countryCode: CountryCode,
    apiKey: string,
    authenticationData: AuthenticationData,
    partner: string,
    applicationId: string,
    formFieldsInput: IFieldState[],
    consentFieldsInput: IFieldState[],
    consolidations: Debt[],
    kycTemplateVersion?: number,
): Promise<SubmitApplicationResponse> => {
    return apiClient<SubmitApplicationResponse>(`${apiProxyPath}/application/submit/${partner}`, {
        method: 'POST',
        body: createSubmitPayload(
            applicationId,
            languageCode,
            countryCode,
            formFieldsInput,
            consentFieldsInput,
            consolidations,
            kycTemplateVersion,
        ),
        apiKey,
        authenticationData,
        sentryTag: 'submit_application',
        sentryExtra: { partner, countryCode, languageCode },
    });
};
